// ...
import { makeStyles } from "@material-ui/core/styles";
import NProgress from "nprogress";
import React, { Fragment, Suspense, useEffect, useMemo } from "react";
import { Route, Switch } from "react-router-dom";

import ErrorBoundary from "../components/ErrorBoundary";
import LoadingInner from "../components/LoadingInner";
import LoadingScreen from "../components/LoadingScreen";
// ...
import EventRoutes from "./event.routes";

const nprogressStyle = makeStyles((theme) => ({
  "@global": {
    "#nprogress": {
      pointerEvents: "none",
      "& .bar": {
        top: 0,
        left: 0,
        height: 2,
        width: "100%",
        position: "fixed",
        zIndex: theme.zIndex.snackbar,
        backgroundColor: theme.palette.primary.main,
        boxShadow: `0 0 2px ${theme.palette.primary.main}`,
      },
      "& .peg": {
        right: 0,
        opacity: 1,
        width: 100,
        height: "100%",
        display: "block",
        position: "absolute",
        transform: "rotate(3deg) translate(0px, -4px)",
        boxShadow: `0 0 10px ${theme.palette.primary.main}, 0 0 5px ${theme.palette.primary.main}`,
      },
    },
  },
}));

function RouteProgress(props) {
  nprogressStyle();

  NProgress.configure({
    speed: 500,
    showSpinner: false,
  });

  useMemo(() => {
    // NProgress.start();
  }, []);

  useEffect(() => {
    // NProgress.done();
  }, []);

  return <Route {...props} />;
}

export function renderRoutes(routes = []) {
  // ...
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, idx) => {
          const Component = route.component;
          const Guard = route.guard || Fragment;
          let Layout = route.layout || Fragment;
          // ...
          return (
            <RouteProgress
              key={`routes-${idx}`}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    <Suspense fallback={<LoadingInner />}>
                      {/* ZONE « CONTENU DE ROUTE ». Posée le 16/09/2026 — voir le pavé
                          de `components/ErrorBoundary/index.js`.

                          C'est la barrière qui couvre l'écran de la recette du 16/09 :
                          elle est rendue DANS `Layout`, donc la barre du haut et le menu
                          latéral (qui ont chacun la leur) restent debout quand la vue
                          tombe. L'organisateur garde de quoi naviguer au lieu de se
                          retrouver devant un document vide.

                          `resetOn={pathname}` : sans cela la barrière resterait affichée
                          après un changement de route servi par la MÊME `<Route>`. On ne
                          met QUE le `pathname` et pas le hash — un changement d'onglet ne
                          réparerait pas une vue morte, et le hash est le canal du jeton
                          (cf. `views/EventAuth/index.js`). */}
                      <ErrorBoundary
                        zone="route-content"
                        resetOn={props.location?.pathname}
                        title="This page couldn't be displayed"
                        message="Something went wrong while rendering this page, so we stopped here rather than leave you on a blank screen. Your event is safe — nothing you had already saved has been lost. Try again below; if it keeps happening, reopen Setup from your organizer dashboard and tell us what you were doing.">
                        <Component {...props} />
                      </ErrorBoundary>
                    </Suspense>
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  );
}

const routes = EventRoutes;

export default routes;
